import {isDef} from '../util/util'
import echarts from 'echarts'
// 基类 所有图表的父类
var Base = function () {
    this.option = {}
    this.optionSet = {}
    this.type = ''
}
Base.prototype = {
    getTitle: function () {
        return {}
    },
    getTooltip: function () {
        let axisPointerType = isDef(this.optionSet.axisPointerType) ? this.optionSet.axisPointerType : 'shadow'
        let unit = isDef(this.optionSet.unit1) ? this.optionSet.unit1 : '';
        let labelDesp=isDef(this.optionSet.labelDesp)?this.optionSet.labelDesp:'';
        let isShowLabelDespUnit=isDef(this.optionSet.isShowLabelDespUnit)?this.optionSet.isShowLabelDespUnit:true;
        let type=this.type;
        if (isDef(this.type)) {
            if (this.type.indexOf('pie') > -1) {
                return {
                    trigger: 'item', // 数据项图形触发，主要在散点图，饼图等无类目轴的图表中使用。
                    confine: true,
                    formatter: '{b}<br/> {c}' + unit + '({d}%)'
                    /*  formatter: function(){
                        return '{b}<br/>: {c} ({d}%)';
                      } */
                }
            } else {
                return {
                    trigger: 'axis', // 坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用。
                    confine: true,
                    axisPointer: {
                        type: axisPointerType
                    },
                    formatter: function (params) {
                        let h='';
                        if(params[0].axisValue.indexOf('_')>-1){
                            let d=params[0].axisValue.split('_');
                            if(isShowLabelDespUnit){
                                h=d[0]+'<br />'+labelDesp+d[1]+unit+'<br />';
                            }else {
                                h=d[0]+'<br />'+labelDesp+d[1]+'<br />';
                            }

                        }else {
                            h=params[0].axisValue+' <br />';
                        }
                        for(let i=0;i<params.length;i++){
                            let d=params[i];
                            let u=unit;
                            if(type==='barAndline'){
                                u=d.seriesType==='line'?'%':unit;
                            }
                            h+=d.seriesName+':'+d.value+u+'<br />';
                        }
                        return h;
                    }
                }
            }
        } else {
            return {
                trigger: 'axis', // 坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用。
                confine: true,
                axisPointer: {
                    type: axisPointerType
                },
                formatter: function () {
                }
            }
        }
    },
    getLegend: function (series) {
        let isShowLegend = isDef(this.optionSet.isShowLegend) ? this.optionSet.isShowLegend : true
        let legend = {}
        if (isShowLegend == false) {
            return ''
        } else {
            // legend的位置 left/right/top/bottom 默认 top
            let legendPosition = this.optionSet.legendPosition
            let textStyle = isDef(this.optionSet.legendTextColor) ? this.optionSet.legendTextColor : '#7DACDE'
            let legendTop = {
                orient: 'horizontal',
                top: '10',
                // right: '60%',
                align: 'left'

            }
            if (isDef(legendPosition)) {
                let legendlt = {
                    orient: 'horizontal',
                    top: '10',
                    left: '18%',
                    align: 'left'

                }
                let legendLeft = {
                    // type: 'scroll',
                    orient: 'vertical',
                    top: 'middle',
                    left: '5%',
                    align: 'left'
                }
                let legendRight = {
                    orient: 'vertical',
                    top: 'middle',
                    right: '10',
                    align: 'left'
                }

                let legendBottom = {
                    orient: 'horizontal',
                    bottom: '5',
                    // right: '5%',
                    align: 'left'
                }

                if (legendPosition == 'left') {
                    legend = legendLeft
                } else if (legendPosition == 'right') {
                    legend = legendRight
                } else if (legendPosition == 'top') {
                    legend = legendTop
                } else if (legendPosition == 'bottom') {
                    legend = legendBottom
                } else if (legendPosition == 'lt') {
                    legend = legendlt
                }
                legend.show = isShowLegend
            } else {
                legend = legendTop
            }
            legend.itemWidth = 12
            legend.itemHeight = 12
            legend.data = []
            legend.textStyle = {color: textStyle}
            if (series) {
                for (let item of series) {
                    legend.data.push(item.name)
                }
            }
            /*if (this.type && this.type === 'pie') {
                //legend.icon = 'circle'
            }*/
            return legend
        }
    },
    getDataZoom: function () {
        let orient = this.optionSet.orient
        let endPercent = isDef(this.optionSet.endPercent) ? this.optionSet.endPercent : 10;  //#081229
        let color = '#233B67';
        let dataZoomColor = isDef(this.optionSet.dataZoomColor) ? this.optionSet.dataZoomColor : ['#1eb5e5', '#5ccbb1']
        let dataZoom = [// 给x轴设置滚动条
            {
                startValue: 0, // 默认为0
                endValue: endPercent,
                type: 'slider',
                show: true,
                handleSize: 10, // 滑动条的 左右2个滑动条的大小
                orient: isDef(orient) ? orient : 'horizontal',
                borderWidth: '0',
                borderColor: color,
                //handleColor: '#ddd', // h滑动图标的颜色
                handleStyle: {
                    borderColor: '#cacaca',
                    borderWidth: '0',
                    shadowBlur: 2,
                    background: '#ddd',
                    shadowColor: '#ddd'
                },
                fillerColor: new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
                    // 给颜色设置渐变色 前面4个参数，给第一个设置1，第四个设置0 ，就是水平渐变
                    // 给第一个设置0，第四个设置1，就是垂直渐变
                    offset: 0,
                    color: dataZoomColor[0]
                }, {
                    offset: 1,
                    color: dataZoomColor[1]
                }]),
                backgroundColor: color, // 两边未选中的滑动条区域的颜色
                showDataShadow: false, // 是否显示数据阴影 默认auto
                showDetail: false, // 即拖拽时候是否显示详细数值信息 默认true
                handleIcon: 'M-292,322.2c-3.2,0-6.4-0.6-9.3-1.9c-2.9-1.2-5.4-2.9-7.6-5.1s-3.9-4.8-5.1-7.6c-1.3-3-1.9-6.1-1.9-9.3c0-3.2,0.6-6.4,1.9-9.3c1.2-2.9,2.9-5.4,5.1-7.6s4.8-3.9,7.6-5.1c3-1.3,6.1-1.9,9.3-1.9c3.2,0,6.4,0.6,9.3,1.9c2.9,1.2,5.4,2.9,7.6,5.1s3.9,4.8,5.1,7.6c1.3,3,1.9,6.1,1.9,9.3c0,3.2-0.6,6.4-1.9,9.3c-1.2,2.9-2.9,5.4-5.1,7.6s-4.8,3.9-7.6,5.1C-285.6,321.5-288.8,322.2-292,322.2z',
                filterMode: 'filter'
            },
            // 下面这个属性是里面拖到
            {
                type: 'inside',
                show: true,
                zoomLock: true,
                orient: isDef(orient) ? orient : 'horizontal',
                start: 0, // 默认为1
                end: 50
            }
        ]

        if (orient === 'vertical') {
            dataZoom[0].width = 10
            dataZoom[0].right = 0
        } else {
            dataZoom[0].height = 10
            dataZoom[0].bottom = 0
        }

        return dataZoom
    },
    getSeries: function () {
    },
    getXAxis: function () {
        let axisLabelColor = this.optionSet.xAxisLabelColor
        let splitLineShow = this.optionSet.isShowXAxisSplitLine
        let rotate = isDef(this.optionSet.rotate) ? this.optionSet.rotate : 0
        // let isFormatLabel = isDef(this.optionSet.isFormatLabel) ? this.optionSet.isFormatLabel : true;
        return [
            {
                type: 'category',
                data: [],
                axisLabel: {
                    rotate: rotate,
                    color: isDef(axisLabelColor) ? axisLabelColor : '#ffffff',// x轴的标记字体颜色
                    formatter: function (val) {
                        if(val.toString().indexOf('_') > -1){
                            return val.replace('_','\n');
                        }
                        else return val;
                    }
                },
                axisLine: {
                    show: true,
                    onZeroAxisIndex:0,
                    lineStyle: {
                        color: '#E3E5E9',
                        opacity: 0.6
                    }
                },
                axisTick: {
                    show: false
                },
                splitLine: {
                    show: isDef(splitLineShow) ? splitLineShow : false, // x分割线的显示
                    lineStyle: {
                        type: 'dotted',
                        color: '#E3E5E9',
                        opacity: 0.3
                    }
                }
            }
        ]
    },
    getHorXAxis: function () {
        let axisLabelColor = this.optionSet.xAxisLabelColor
        let splitLineShow = this.optionSet.isShowXAxisSplitLine
        let isShowXAxis = isDef(this.optionSet.isShowXAxis) ? this.optionSet.isShowXAxis : true
        return [
            {
                show: isShowXAxis,
                type: 'value',
                axisLabel: {
                    color: isDef(axisLabelColor) ? axisLabelColor : '#7DB0D2' // x轴的标记字体颜色
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#E3E5E9',
                        opacity: 0.6
                    }
                },
                axisTick: {
                    show: false
                },
                splitLine: {
                    show: isDef(splitLineShow) ? splitLineShow : false, // x分割线的显示
                    lineStyle: {
                        type: 'dotted',
                        color: '#E3E5E9',
                        opacity: 0.3
                    }
                }
            }
        ]
    },
    getYAxis: function (yaxiaArr) {
        let yAxisNameTextStyleColor = this.optionSet.yAxisNameTextStyleColor
        let yAxisLabelColor = this.optionSet.yAxisLabelColor
        let isShowYAxis = isDef(this.optionSet.isShowYAxis) ? this.optionSet.isShowYAxis : true;
        let min=Math.floor(yaxiaArr[0]),max=Math.ceil(yaxiaArr[1]),splitNumber=5;
        return {
            type: 'value',
            show: isShowYAxis,
            name: isDef(this.optionSet.unit1) ? '单位:' + this.optionSet.unit1 : '',
            min: min,
            max: max,
            interval: Math.ceil((max - min) / splitNumber),
            nameTextStyle: {
                padding: [0, 0, 0, 20],
                color: isDef(yAxisNameTextStyleColor) ? yAxisNameTextStyleColor : '#ffffff' // y轴的单位字体样式
            },
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            axisLabel: {
                color: isDef(yAxisLabelColor) ? yAxisLabelColor : '#7186A1' // y轴的标记字体颜色
            },
            splitLine: {
                show: true,
                lineStyle: {
                    type: 'dotted',
                    color: '#E3E5E9',
                    opacity: 0.3
                }
            }
        }
    },
    getHorYAxis: function () {
        const yAxisLabelColor = this.optionSet.yAxisLabelColor
        return {
            type: 'category',
            data: [],
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            axisLabel: {
                color: isDef(yAxisLabelColor) ? yAxisLabelColor : '#B8D9DE' // y轴的标记字体颜色
            },
            splitLine: {
                show: false,
                lineStyle: {
                    type: 'dotted',
                    color: '#E3E5E9',
                    opacity: 0.3
                }
            }

        }
    },
    getDYAxis: function (yaxiaArr) {
        let splitNumber = 5;
        let min0 = Math.floor(yaxiaArr[0]);
        let max0 =  Math.ceil(yaxiaArr[1]);
        let min1 =  Math.floor(yaxiaArr[2]);
        let max1 =  Math.ceil(yaxiaArr[3]);
        let color = '#7186A1';
        let lineColor = '#2A5782';
        return [{
            type: 'value',
            name: isDef(this.optionSet.unit1) ? '单位:' + this.optionSet.unit1 : '',
            nameTextStyle: isDef(this.optionSet.unit1) ? {
                color: '#ffffff'
            } : '',
            min: min0,
            max: max0,
            interval: (max0 - min0) / splitNumber,
            //interval: Math.ceil((max0 - min0) / splitNumber),
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            splitLine: {
                lineStyle: {
                    color: lineColor,
                    type: 'dashed',
                    opacity: 0.5
                }
            },
            axisLabel: {
                color: color,
                formatter: '{value}'
            }
        }, {
            type: 'value',
            name: isDef(this.optionSet.unit2) ? '单位:' + this.optionSet.unit2 : '',
            nameTextStyle: isDef(this.optionSet.unit2) ? {
                color: '#3698FF '
            } : '',
            min: min1,

            //interval: Math.ceil((max1 - min1) / splitNumber),
            max: max1,
            interval: (max1 - min1) / splitNumber,
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            splitLine: {
                lineStyle: {
                    type: 'dashed',
                    color: lineColor,
                    opacity: 0.5
                }
            },
            axisLabel: {
                color: color,
                formatter: '{value}%'
            }
        }]
    },
    getGrid: function () {
        let num1 = 40, num2 = 20,bnum=10;
        let top = '', left = '', right = '', bottom = ''
        let isshowLegend = isDef(this.optionSet.isShowLegend) ? this.optionSet.isShowLegend : true
        if (isshowLegend == false) {
            // top=num2
            top = left = right = bottom = num2
        } else {
            let legendPosition = isDef(this.optionSet.legendPosition) ? this.optionSet.legendPosition : 'top'
            if (legendPosition == 'top' || legendPosition == 'lt') {
                top = num1
                bottom = bnum;
                left = right = num2
            } else if (legendPosition == 'left') {
                left = num1
                top = right = bottom = num2
            } else if (legendPosition == 'right') {
                right = num1
                top = left = bottom = num2
            } else if (legendPosition == 'bottom') {
                bottom = num1
                top = left = right = num2
            }
        }
        return {
            top: top,
            left: left,
            right: right,
            bottom: bottom,
            containLabel: true
        }
    },

    getToolbox: function () {
        // let downloadImageName=isDef(this.optionSet.downloadImageName)?this.optionSet.downloadImageName:'图片下载'
        return {
            right: '30'
            /* feature: {
                 saveAsImage: {
                   name:downloadImageName
               }
             }*/
        }
    },
    init: function () {
    }
}
export default Base
